module.exports = __webpack_public_path__ + "static/media/sunpharma.8e5ed094.svg";